// removed by extract-text-webpack-plugin
module.exports = {"menu":"_7Sv3kM3CoAhfFOdS6NVhh","menuItem":"_1xajPxJY7JzKV5N24Miqx5","active":"_3F7btQkk_wuhNw6x8Ml2qb","arrow":"_22qb5bgAntt7ZAInNdEYE_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SecondaryMenu/SecondaryMenu.css
// module id = 481
// module chunks = 0